import { style } from "@vanilla-extract/css";
import { primitiveTokens } from "../../theme/ThemeTokens.css";

export const appErrorActions = style({
  display: "flex",
  gap: primitiveTokens.sizing["4x"],
  justifyContent: "center",
  flexWrap: "wrap"
});
